import React, { useEffect, useRef } from 'react';

export const usePolling = (
  callback: () => Promise<void>,
  intervalMs: number,
  deps: React.DependencyList = [],
  onCleanUp?: () => void,
) => {
  const timeoutIdRef = useRef(null);
  useEffect(() => {
    let _stopped = false;
    (async function pollingCallback() {
      try {
        await callback();
      } finally {
        timeoutIdRef.current = !_stopped && setTimeout(pollingCallback, intervalMs);
      }
    })();

    return () => {
      _stopped = true;
      clearTimeout(timeoutIdRef.current);
      if (onCleanUp) {
        onCleanUp();
      }
    };
  }, deps);
};
